'use client';

import { useTranslations } from 'next-intl';
import { Button } from '@/app/components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/app/components/ui/dialog';
import { useCopy } from '@/app/hooks';
import type { LiveAvatar } from '@/app/types';
import { reportEvent } from '@/app/utils';
import { isUserBannerAvatar } from '../utils';

interface ShareAvatarDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** 分享落地页链接，形如 `${origin}/vidu-stream/share-avatar/${roleId}`。 */
  shareUrl: string;
  role: LiveAvatar;
}

export const ShareAvatarDialog = ({ open, onOpenChange, shareUrl, role }: ShareAvatarDialogProps) => {
  const t = useTranslations('vidu-stream.avatars');
  const { copy } = useCopy();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="flex w-[min(480px,calc(100%-32px))] max-w-none flex-col gap-0 border-system-white08 bg-[#1c1c1c] p-0 text-white"
        onClose={() => onOpenChange(false)}
      >
        <DialogHeader className="shrink-0 gap-0 space-y-0 px-6 pt-6 pb-3">
          <DialogTitle className="text-left font-medium text-white text-xl leading-tight">
            {t('share.title')}
          </DialogTitle>
        </DialogHeader>
        <p className="whitespace-pre-line px-6 pb-6 text-sm text-white/60 leading-relaxed">{t('share.description')}</p>
        <div className="flex shrink-0 justify-end px-6 pb-6">
          <Button
            variant="primary"
            size="dialog"
            className="min-w-[120px]"
            onClick={() => {
              copy(shareUrl, { copySuccessMessage: t('menu.linkCopied') });
              reportEvent('stream_element_click', {
                element_name: 'copy_link_click',
                stream_character_name: role.name ?? '',
                stream_character_id: role.id ?? '',
                stream_character_type: isUserBannerAvatar(role) ? 'ugc' : 'pgc',
              });
              onOpenChange(false);
            }}
          >
            {t('share.copyLink')}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
